var _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterSendAnim(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "150px",
    width: "150px",
    viewBox: "0 0 300 300",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "i0"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "discrete",
    dur: "2s",
    values: "none; inline; inline",
    keyTimes: "0; 0.8325; 1",
    attributeName: "display"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.073,150.073)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.934,0.934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    type: "scale",
    attributeName: "transform",
    dur: "2s",
    begin: "0s",
    calcMode: "spline",
    values: "0.934 0.934; 0.934 0.934; 1.214 1.214; 1.214 1.214",
    keyTimes: "0; 0.833333; 0.983333; 1",
    keySplines: "0 0 1 1; 0.915 0.651 0.203 0.507; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-99,-99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,98.939,98.939)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00da8f",
    d: "M23.036,-85.967C70.515,-73.245,98.69,-24.443,85.969,23.035C73.246,70.514,24.443,98.689,-23.035,85.967C-70.513,73.244,-98.689,24.443,-85.966,-23.035C-73.245,-70.514,-24.443,-98.689,23.036,-85.967Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,98.943,102.024)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-26.138,30.587C-27.562,31.392,-29.368,30.907,-30.199,29.498C-30.199,29.498,-58.899,-19.189,-58.899,-19.189C-59.829,-21.088,-60,-23.257,-59.378,-25.261C-58.756,-27.267,-57.386,-28.958,-55.542,-30.001C-53.698,-31.043,-51.516,-31.358,-49.433,-30.884C-47.349,-30.41,-45.517,-29.181,-44.302,-27.441C-44.302,-27.441,-23.618,7.647,-23.618,7.647C-23.065,8.586,-21.86,8.908,-20.911,8.371C-20.911,8.371,47.571,-30.344,47.571,-30.344C49.492,-31.243,51.695,-31.392,53.736,-30.76C55.778,-30.129,57.509,-28.766,58.584,-26.94C59.66,-25.117,60,-22.965,59.537,-20.918C59.074,-18.871,57.842,-17.079,56.086,-15.898C56.086,-15.898,-26.138,30.587,-26.138,30.587Z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "discrete",
    dur: "2s",
    values: "none; inline; inline",
    keyTimes: "0; 0.2825; 1",
    attributeName: "display"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0.02; 0.02",
    keyTimes: "0; 0.7; 0.866667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148,146)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.62,0.62)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    type: "scale",
    attributeName: "transform",
    dur: "2s",
    begin: "0s",
    calcMode: "spline",
    values: "0.62 0.62; 0.62 0.62; 0.928 0.928; 1.033 1.033; 1.103 1.103; 1.153 1.153; 1.191 1.191; 1.221 1.221; 1.245 1.245; 1.263 1.263; 1.278 1.278; 1.29 1.29; 1.298 1.298; 1.305 1.305; 1.309 1.309; 1.311 1.311; 1.312 1.312; 1.312 1.312; 1.311 1.311; 1.308 1.308; 1.305 1.305; 1.301 1.301; 1.296 1.296; 1.291 1.291; 1.286 1.286; 1.28 1.28; 1.274 1.274; 1.268 1.268; 1.262 1.262; 1.257 1.257; 1.252 1.252; 1.247 1.247; 1.243 1.243; 1.241 1.241; 1.24 1.24; 1.24 1.24",
    keyTimes: "0; 0.283334; 0.3; 0.316667; 0.333333; 0.35; 0.366667; 0.383333; 0.4; 0.416667; 0.433333; 0.45; 0.466667; 0.483333; 0.5; 0.516667; 0.533333; 0.55; 0.566667; 0.583334; 0.6; 0.616667; 0.633334; 0.65; 0.666667; 0.683334; 0.7; 0.716667; 0.733334; 0.75; 0.766667; 0.783334; 0.8; 0.816667; 0.833334; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-95.5,-98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(0.68,0,0,0.68,12.829,84.352)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd5e75",
    d: "M-2.421,-11.243C3.788,-12.58,9.905,-8.631,11.243,-2.423C12.58,3.786,8.631,9.905,2.422,11.242C-3.787,12.58,-9.905,8.63,-11.243,2.421C-12.58,-3.788,-8.63,-9.906,-2.421,-11.243Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(0.67,0,0,0.67,178.004,59.795)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1e52c7",
    d: "M-2.423,-11.242C3.786,-12.579,9.904,-8.631,11.241,-2.422C12.579,3.787,8.63,9.904,2.421,11.242C-3.788,12.579,-9.905,8.631,-11.243,2.422C-12.58,-3.787,-8.631,-9.905,-2.423,-11.242Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(0.7,0,0,0.7,103.291,12.83)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcb939",
    d: "M-2.421,-11.243C3.788,-12.58,9.905,-8.631,11.242,-2.423C12.58,3.786,8.63,9.905,2.421,11.242C-3.788,12.58,-9.905,8.63,-11.243,2.421C-12.58,-3.788,-8.63,-9.906,-2.421,-11.243Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(0.7,0,0,0.7,63.997,183.011)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1e52c7",
    d: "M-2.421,-11.242C3.788,-12.58,9.904,-8.631,11.242,-2.422C12.579,3.787,8.631,9.904,2.422,11.242C-3.787,12.579,-9.905,8.631,-11.243,2.422C-12.58,-3.786,-8.63,-9.905,-2.421,-11.242Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(0.71,0,0,0.71,173.998,145.423)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9917ec",
    d: "M-2.421,-11.243C3.787,-12.58,9.905,-8.631,11.242,-2.422C12.58,3.787,8.63,9.904,2.421,11.241C-3.788,12.579,-9.905,8.63,-11.243,2.421C-12.58,-3.788,-8.63,-9.905,-2.421,-11.243Z"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.06,150.061)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    type: "scale",
    attributeName: "transform",
    dur: "2s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 0.27 0.27; 1 1; 1 1",
    keyTimes: "0; 0.2; 0.35; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-99,-99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,98.939,98.939)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M23.036,-85.967C70.515,-73.245,98.69,-24.443,85.969,23.035C73.246,70.514,24.443,98.689,-23.035,85.967C-70.513,73.244,-98.689,24.443,-85.966,-23.035C-73.245,-70.514,-24.443,-98.689,23.036,-85.967Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "2s",
    begin: "0s",
    fill: "freeze",
    values: "#e6e6e6; #e6e6e6; #43d296; #43d296",
    keyTimes: "0; 0.166667; 0.483333; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(0.816,-0.182,0.182,0.816,99.943,103.024)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-26.138,30.587C-27.562,31.392,-29.368,30.907,-30.199,29.498C-30.199,29.498,-58.899,-19.189,-58.899,-19.189C-59.829,-21.088,-60,-23.257,-59.378,-25.261C-58.756,-27.267,-57.386,-28.958,-55.542,-30.001C-53.698,-31.043,-51.516,-31.358,-49.433,-30.884C-47.349,-30.41,-45.517,-29.181,-44.302,-27.441C-44.302,-27.441,-23.618,7.647,-23.618,7.647C-23.065,8.586,-21.86,8.908,-20.911,8.371C-20.911,8.371,47.571,-30.344,47.571,-30.344C49.492,-31.243,51.695,-31.392,53.736,-30.76C55.778,-30.129,57.509,-28.766,58.584,-26.94C59.66,-25.117,60,-22.965,59.537,-20.918C59.074,-18.871,57.842,-17.079,56.086,-15.898C56.086,-15.898,-26.138,30.587,-26.138,30.587Z"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.098,0,0,1.019,147,146)",
    display: "none",
    id: "i7"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "discrete",
    dur: "2s",
    values: "none; inline; inline",
    keyTimes: "0; 0.2825; 1",
    attributeName: "display"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,-1.5,-0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    display: "none",
    strokeDasharray: "0 100.001",
    pathLength: 100,
    strokeLinecap: "round",
    strokeWidth: 5,
    stroke: "#fd5e75",
    d: "M-57.75,-75.75C-57.75,-75.75,-57,-106.5,-90.75,-107.5"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "linear",
    keyTimes: "0; 0.283333; 0.291667; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341667; 0.35; 0.358333; 0.366667; 0.383333; 0.391667; 0.408333; 0.416667; 0.425; 0.441667; 0.458333; 0.475; 0.483333; 0.491667; 0.5; 0.508333; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.558333; 0.566667; 0.575; 0.583333; 0.591667; 0.6; 0.608333; 0.616667; 0.625; 0.633333; 0.65; 0.666667; 0.683333; 0.7; 0.716667; 0.733333; 0.741667; 0.75; 0.758333; 0.770182; 0.775; 0.783333; 0.791667; 0.8; 0.808333; 0.816667; 0.825; 0.833333; 0.841667; 0.85; 1",
    values: "0 100.001; 0 100.001; 0.09 99.911; 0.34 99.661; 0.77 99.231; 1.34 98.661; 2.08 97.921; 2.95 97.051; 3.97 96.031; 5.12 94.881; 6.4 93.601; 7.79 92.211; 10.93 89.071; 12.66 87.341; 16.4 83.601; 18.4 81.601; 20.48 79.521; 24.86 75.141; 29.48 70.521; 34.27 65.731; 36.45 63.551; 38.4 61.601; 40.11 59.891; 41.6 58.401; 42.86 57.141; 43.93 56.071; 44.77 55.231; 45.43 54.571; 45.89 54.111; 46.16 53.841; 46.25 53.751; 46.17 53.831; 45.93 54.071; 45.53 54.471; 44.98 55.021; 44.27 55.731; 43.44 56.561; 42.47 57.531; 41.38 58.621; 38.85 61.151; 35.89 64.111; 32.57 67.431; 28.95 71.051; 25.06 74.941; 20.96 79.041; 18.85 81.151; 16.71 83.291; 14.54 85.461; 11.44 88.561; 10.2 89.801; 8.2 91.801; 6.38 93.621; 4.77 95.231; 3.36 96.641; 2.19 97.811; 1.25 98.751; 0.56 99.441; 0.14 99.861; 0 100.001; 0 100.001",
    attributeName: "stroke-dasharray"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "linear",
    keyTimes: "0; 0.283333; 0.291667; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341667; 0.35; 0.358333; 0.366667; 0.383333; 0.391667; 0.408333; 0.416667; 0.425; 0.441667; 0.458333; 0.475; 0.483333; 0.491667; 0.5; 0.508333; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.558333; 0.566667; 0.575; 0.583333; 0.591667; 0.6; 0.608333; 0.616667; 0.625; 0.633333; 0.65; 0.666667; 0.683333; 0.7; 0.716667; 0.733333; 0.741667; 0.75; 0.758333; 0.770182; 0.775; 0.783333; 0.791667; 0.8; 0.808333; 0.816667; 0.825; 0.833333; 0.841667; 0.85; 1",
    values: "0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; -0.03; -0.32; -0.87; -1.68; -2.74; -4.03; -5.53; -7.25; -9.16; -11.25; -13.51; -15.93; -18.49; -21.18; -23.99; -26.9; -29.91; -32.99; -36.14; -39.35; -45.87; -52.46; -59.01; -65.41; -71.58; -77.41; -80.16; -82.79; -85.28; -88.56; -89.8; -91.8; -93.62; -95.23; -96.64; -97.81; -98.75; -99.44; -99.86; -100; -100",
    attributeName: "stroke-dashoffset"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "discrete",
    keyTimes: "0; 0.283333; 0.285322; 0.848452; 1",
    values: "none; none; inline; none; none",
    attributeName: "display"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-21,347)",
    display: "none",
    id: "i9"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "discrete",
    dur: "2s",
    values: "none; inline; inline",
    keyTimes: "0; 0.2825; 1",
    attributeName: "display"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    display: "none",
    strokeDasharray: "0 100.001",
    pathLength: 100,
    strokeLinecap: "round",
    strokeWidth: 5,
    stroke: "#9917ec",
    d: "M90.75,-122.25C90.75,-122.25,104,-106,83.5,-110.5C63,-115,81.25,-97.25,81.25,-97.25C81.25,-97.25,88,-84,69.75,-93.25C51.5,-102.5,64.5,-79,61,-75.75"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "linear",
    keyTimes: "0; 0.283333; 0.291667; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341667; 0.35; 0.358333; 0.366667; 0.383333; 0.391667; 0.408333; 0.416667; 0.425; 0.441667; 0.458333; 0.475; 0.483333; 0.491667; 0.5; 0.508333; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.558333; 0.566667; 0.575; 0.583333; 0.591667; 0.6; 0.608333; 0.616667; 0.625; 0.633333; 0.65; 0.666667; 0.683333; 0.7; 0.716667; 0.733333; 0.741667; 0.75; 0.758333; 0.770182; 0.775; 0.783333; 0.791667; 0.8; 0.808333; 0.816667; 0.825; 0.833333; 0.841667; 0.85; 1",
    values: "0 100.001; 0 100.001; 0.09 99.911; 0.34 99.661; 0.77 99.231; 1.34 98.661; 2.08 97.921; 2.95 97.051; 3.97 96.031; 5.12 94.881; 6.4 93.601; 7.79 92.211; 10.93 89.071; 12.66 87.341; 16.4 83.601; 18.4 81.601; 20.48 79.521; 24.86 75.141; 29.48 70.521; 34.27 65.731; 36.45 63.551; 38.4 61.601; 40.11 59.891; 41.6 58.401; 42.86 57.141; 43.93 56.071; 44.77 55.231; 45.43 54.571; 45.89 54.111; 46.16 53.841; 46.25 53.751; 46.17 53.831; 45.93 54.071; 45.53 54.471; 44.98 55.021; 44.27 55.731; 43.44 56.561; 42.47 57.531; 41.38 58.621; 38.85 61.151; 35.89 64.111; 32.57 67.431; 28.95 71.051; 25.06 74.941; 20.96 79.041; 18.85 81.151; 16.71 83.291; 14.54 85.461; 11.44 88.561; 10.2 89.801; 8.2 91.801; 6.38 93.621; 4.77 95.231; 3.36 96.641; 2.19 97.811; 1.25 98.751; 0.56 99.441; 0.14 99.861; 0 100.001; 0 100.001",
    attributeName: "stroke-dasharray"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "linear",
    keyTimes: "0; 0.283333; 0.291667; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341667; 0.35; 0.358333; 0.366667; 0.383333; 0.391667; 0.408333; 0.416667; 0.425; 0.441667; 0.458333; 0.475; 0.483333; 0.491667; 0.5; 0.508333; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.558333; 0.566667; 0.575; 0.583333; 0.591667; 0.6; 0.608333; 0.616667; 0.625; 0.633333; 0.65; 0.666667; 0.683333; 0.7; 0.716667; 0.733333; 0.741667; 0.75; 0.758333; 0.770182; 0.775; 0.783333; 0.791667; 0.8; 0.808333; 0.816667; 0.825; 0.833333; 0.841667; 0.85; 1",
    values: "0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; -0.03; -0.32; -0.87; -1.68; -2.74; -4.03; -5.53; -7.25; -9.16; -11.25; -13.51; -15.93; -18.49; -21.18; -23.99; -26.9; -29.91; -32.99; -36.14; -39.35; -45.87; -52.46; -59.01; -65.41; -71.58; -77.41; -80.16; -82.79; -85.28; -88.56; -89.8; -91.8; -93.62; -95.23; -96.64; -97.81; -98.75; -99.44; -99.86; -100; -100",
    attributeName: "stroke-dashoffset"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "discrete",
    keyTimes: "0; 0.283333; 0.285322; 0.848452; 1",
    values: "none; none; inline; none; none",
    attributeName: "display"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.842,-0.357,0.349,-0.823,132.583,96.106)",
    display: "none",
    id: "i10"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "discrete",
    dur: "2s",
    values: "none; inline; inline",
    keyTimes: "0; 0.2825; 1",
    attributeName: "display"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    display: "none",
    strokeDasharray: "0 100.001",
    pathLength: 100,
    strokeLinecap: "round",
    strokeWidth: 5,
    stroke: "#fcb939",
    d: "M-75,68.75C-75,68.75,-77.791,111.584,-107.25,86.5C-132.5,65,-89,58.25,-94,84C-99.515,112.405,-123,112.25,-128.75,113"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "linear",
    keyTimes: "0; 0.283333; 0.291667; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341667; 0.35; 0.358333; 0.366667; 0.383333; 0.391667; 0.408333; 0.416667; 0.425; 0.441667; 0.458333; 0.475; 0.483333; 0.491667; 0.5; 0.508333; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.558333; 0.566667; 0.575; 0.583333; 0.591667; 0.6; 0.608333; 0.616667; 0.625; 0.633333; 0.65; 0.666667; 0.683333; 0.7; 0.716667; 0.733333; 0.741667; 0.75; 0.758333; 0.770182; 0.775; 0.783333; 0.791667; 0.8; 0.808333; 0.816667; 0.825; 0.833333; 0.841667; 0.85; 1",
    values: "0 100.001; 0 100.001; 0.09 99.911; 0.34 99.661; 0.77 99.231; 1.34 98.661; 2.08 97.921; 2.95 97.051; 3.97 96.031; 5.12 94.881; 6.4 93.601; 7.79 92.211; 10.93 89.071; 12.66 87.341; 16.4 83.601; 18.4 81.601; 20.48 79.521; 24.86 75.141; 29.48 70.521; 34.27 65.731; 36.45 63.551; 38.4 61.601; 40.11 59.891; 41.6 58.401; 42.86 57.141; 43.93 56.071; 44.77 55.231; 45.43 54.571; 45.89 54.111; 46.16 53.841; 46.25 53.751; 46.17 53.831; 45.93 54.071; 45.53 54.471; 44.98 55.021; 44.27 55.731; 43.44 56.561; 42.47 57.531; 41.38 58.621; 38.85 61.151; 35.89 64.111; 32.57 67.431; 28.95 71.051; 25.06 74.941; 20.96 79.041; 18.85 81.151; 16.71 83.291; 14.54 85.461; 11.44 88.561; 10.2 89.801; 8.2 91.801; 6.38 93.621; 4.77 95.231; 3.36 96.641; 2.19 97.811; 1.25 98.751; 0.56 99.441; 0.14 99.861; 0 100.001; 0 100.001",
    attributeName: "stroke-dasharray"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "linear",
    keyTimes: "0; 0.283333; 0.291667; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341667; 0.35; 0.358333; 0.366667; 0.383333; 0.391667; 0.408333; 0.416667; 0.425; 0.441667; 0.458333; 0.475; 0.483333; 0.491667; 0.5; 0.508333; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.558333; 0.566667; 0.575; 0.583333; 0.591667; 0.6; 0.608333; 0.616667; 0.625; 0.633333; 0.65; 0.666667; 0.683333; 0.7; 0.716667; 0.733333; 0.741667; 0.75; 0.758333; 0.770182; 0.775; 0.783333; 0.791667; 0.8; 0.808333; 0.816667; 0.825; 0.833333; 0.841667; 0.85; 1",
    values: "0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; -0.03; -0.32; -0.87; -1.68; -2.74; -4.03; -5.53; -7.25; -9.16; -11.25; -13.51; -15.93; -18.49; -21.18; -23.99; -26.9; -29.91; -32.99; -36.14; -39.35; -45.87; -52.46; -59.01; -65.41; -71.58; -77.41; -80.16; -82.79; -85.28; -88.56; -89.8; -91.8; -93.62; -95.23; -96.64; -97.81; -98.75; -99.44; -99.86; -100; -100",
    attributeName: "stroke-dashoffset"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "discrete",
    keyTimes: "0; 0.283333; 0.285322; 0.848452; 1",
    values: "none; none; inline; none; none",
    attributeName: "display"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,151,151)",
    display: "none",
    id: "i11"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "discrete",
    dur: "2s",
    values: "none; inline; inline",
    keyTimes: "0; 0.2825; 1",
    attributeName: "display"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    display: "none",
    strokeDasharray: "0 100.001",
    pathLength: 100,
    strokeLinecap: "round",
    strokeWidth: 5,
    stroke: "#1e52c7",
    d: "M61,78.5C61,78.5,55.5,93,78,100.5C100.5,108,94,115.5,94,115.5"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "linear",
    keyTimes: "0; 0.283333; 0.291667; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341667; 0.35; 0.358333; 0.366667; 0.383333; 0.391667; 0.408333; 0.416667; 0.425; 0.441667; 0.458333; 0.475; 0.483333; 0.491667; 0.5; 0.508333; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.558333; 0.566667; 0.575; 0.583333; 0.591667; 0.6; 0.608333; 0.616667; 0.625; 0.633333; 0.65; 0.666667; 0.683333; 0.7; 0.716667; 0.733333; 0.741667; 0.75; 0.758333; 0.770182; 0.775; 0.783333; 0.791667; 0.8; 0.808333; 0.816667; 0.825; 0.833333; 0.841667; 0.85; 1",
    values: "0 100.001; 0 100.001; 0.09 99.911; 0.34 99.661; 0.77 99.231; 1.34 98.661; 2.08 97.921; 2.95 97.051; 3.97 96.031; 5.12 94.881; 6.4 93.601; 7.79 92.211; 10.93 89.071; 12.66 87.341; 16.4 83.601; 18.4 81.601; 20.48 79.521; 24.86 75.141; 29.48 70.521; 34.27 65.731; 36.45 63.551; 38.4 61.601; 40.11 59.891; 41.6 58.401; 42.86 57.141; 43.93 56.071; 44.77 55.231; 45.43 54.571; 45.89 54.111; 46.16 53.841; 46.25 53.751; 46.17 53.831; 45.93 54.071; 45.53 54.471; 44.98 55.021; 44.27 55.731; 43.44 56.561; 42.47 57.531; 41.38 58.621; 38.85 61.151; 35.89 64.111; 32.57 67.431; 28.95 71.051; 25.06 74.941; 20.96 79.041; 18.85 81.151; 16.71 83.291; 14.54 85.461; 11.44 88.561; 10.2 89.801; 8.2 91.801; 6.38 93.621; 4.77 95.231; 3.36 96.641; 2.19 97.811; 1.25 98.751; 0.56 99.441; 0.14 99.861; 0 100.001; 0 100.001",
    attributeName: "stroke-dasharray"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "linear",
    keyTimes: "0; 0.283333; 0.291667; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341667; 0.35; 0.358333; 0.366667; 0.383333; 0.391667; 0.408333; 0.416667; 0.425; 0.441667; 0.458333; 0.475; 0.483333; 0.491667; 0.5; 0.508333; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.558333; 0.566667; 0.575; 0.583333; 0.591667; 0.6; 0.608333; 0.616667; 0.625; 0.633333; 0.65; 0.666667; 0.683333; 0.7; 0.716667; 0.733333; 0.741667; 0.75; 0.758333; 0.770182; 0.775; 0.783333; 0.791667; 0.8; 0.808333; 0.816667; 0.825; 0.833333; 0.841667; 0.85; 1",
    values: "0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; 0; -0.03; -0.32; -0.87; -1.68; -2.74; -4.03; -5.53; -7.25; -9.16; -11.25; -13.51; -15.93; -18.49; -21.18; -23.99; -26.9; -29.91; -32.99; -36.14; -39.35; -45.87; -52.46; -59.01; -65.41; -71.58; -77.41; -80.16; -82.79; -85.28; -88.56; -89.8; -91.8; -93.62; -95.23; -96.64; -97.81; -98.75; -99.44; -99.86; -100; -100",
    attributeName: "stroke-dashoffset"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    begin: "0s",
    dur: "2s",
    calcMode: "discrete",
    keyTimes: "0; 0.283333; 0.285322; 0.848452; 1",
    values: "none; none; inline; none; none",
    attributeName: "display"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterSendAnim);
export default __webpack_public_path__ + "static/media/afterSend_anim.0cdeac1fc4389184244aab0fd82c0839.svg";
export { ForwardRef as ReactComponent };